import React, { useEffect, useState } from "react";
import {
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import List from "./List";
import {
  InputField,
} from "forms/hoc/formfield";
import SearchIcon from "asset/images/images/search.svg";
import useForm from "forms/hooks/useForm";
import { Filterchema } from "forms/hooks/validateRules";
import { commonService } from "forms/helpers/common.service";
import dayjs from "dayjs";
import { Failed } from "forms/helpers/toast.helper";
import { errorMessage } from "forms/helpers/function.helper";
import Loader from "ui-component/Loader";
import { debounce } from "helpers/debounce";
import { format } from "date-fns";

const SeoManagement = () => {
  const theme = useTheme();
  const [search, setSearch] = useState<any>();
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  let [order, setOrder] = useState<any>("ASC");
  let [orderBy, setOrderBy] = useState("createdAt");
  const [count, setCount] = useState(0);
  let [tableData, setTableData] = useState<any>();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isModal, setIsmodal] = useState<any>();
  const [filterSubmit, setFilterSubmit] = useState<boolean>(false);
  const [filteractive, setFilterActive] = useState<any>(false);

  const [initialLoad, setInitialLoad] = useState<boolean>(true);
  const [selectedDuration, setSelectedDuration] = useState<any>();

  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  const Downloadstyle = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: matchDownMD ? 300 : 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "12px",
    p: 4,
  };

  const calculateDateRange = (durationValue: any) => {
    let from = dayjs();
    let to = dayjs();

    switch (durationValue) {
      case "last one week":
        from = from.subtract(1, "week");
        break;
      case "last one month":
        from = from.subtract(1, "month");
        break;
      case "last three months":
        from = from.subtract(3, "months");
        break;
      default:
        return { from: null, to: null };
    }

    return {
      from: from?.format("YYYY-MM-DD"),
      to: to?.format("YYYY-MM-DD"),
    };
  };
  const [dateRange, setDateRange] = useState(calculateDateRange("custom date"));

  useEffect(() => {
    if (selectedDuration?.value !== "custom date") {
      setDateRange(calculateDateRange(selectedDuration?.value));
    }
  }, [selectedDuration]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  function getTableData() {
    setLoading(true);

    const params = new URLSearchParams({
      per_page: rowsPerPage.toString(),
      page: (page + 1).toString(),
      sort_order: order,
      sort_by: orderBy,
      search: search ?? "", 
      search_by: "page,title",
    }).toString();

    commonService
      .getServices(`/admin/seodata-list?${params}`)
      .then((res: any) => {
        const data = res?.data?.data?.results.map((item: any) => {
          const date: any = item?.updatedAt
          ? new Date(item?.updatedAt)
          : null;
          return {
            ...item,
            id: item?._id,
            updatedAt: date ? format(date, "yyyy-MM-dd") : "N/A",            
          };
        });

        setTableData(data);
        setCount(res?.data?.data?.pagination?.total);
        setInitialLoad(false);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Failed(errorMessage(error, "Oops! Something went wrong"));
      });
  }
  /* per page row handle */
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "ASC";
    order = isAsc ? "DESC" : "ASC";
    setOrder(order);
    setPage(0);
    orderBy = property;
    setOrderBy(orderBy);
  };

  const handleSearch = async (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPage(0);
    setSearch((pre: any) => (pre = e.target.value));
  };
  const handleFilter = () => {
    setOpen(false);
    setPage(0);
    setFilterSubmit(true);
  };

  useEffect(() => {
    getTableData();
  }, [rowsPerPage, page, orderBy, order, filterSubmit, filteractive]);

  useEffect(() => {
    const delay = 500; 
    const performSearch = (text: string) => {
      if (initialLoad) return;
      if (page == 0) getTableData();
      else {
        setPage(0);
      }
    };
    const debouncedSearch = debounce(performSearch, delay);
    const timeoutId = setTimeout(() => debouncedSearch(search), delay);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [search]);

  return (
    <Box sx={{ padding: " 20px" }}>
      {isLoading && <Loader />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ minWidth: "30%" }}>
          <InputField
            placeholder="Search by Page , Title"
            values={search}
            name="password"
            handleChange={handleSearch}
            id="password"
            adorament="startAdornment"
            Icon={<img src={SearchIcon} alt="search" />}
            position="start"
            type="text"
            isRequired={false}
          />
        </Box>
      </Box>
      <Box sx={{ padding: "20px 0" }}>
        {!isLoading && (
          <List
            search={search}
            setPage={setPage}
            page={page}
            setIsmodal={setIsmodal}
            rowsPerPage={rowsPerPage}
            tableData={tableData}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleRequestSort={handleRequestSort}
            order={order}
            orderBy={orderBy}
            isLoading={isLoading}
            count={count}
            getTableData={getTableData}
            setLoading={setLoading}
          />
        )}
      </Box>
    </Box>
  );
};

export default SeoManagement;
